import { createTheme } from "@mui/material";

export const THEME = createTheme({
  palette: {
    primary: {
      main: "#364F6B",
    },
    success: {
      main: "#529359",
      contrastText: "#fff",
    },
    // Warm complement to the navy primary, for the rare element that has to be
    // noticed against it (drawer counts, attention markers). Deep enough that
    // white text clears WCAG AA at small sizes — a lighter orange does not.
    accent: {
      main: "#C2410C",
      contrastText: "#fff",
    },
    drawer: {
      main: "#364F6B",
      light: "#9ea7d8", // Lighter shade for text or icons
      highlight: "#293c51", // Darker shade or hover state
    },
    background: {
      default: "#f7f7f7",
    },
  },
  typography: {
    allVariants: {
      color: "#000",
    },
    fontFamily: [
      "Poppins",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        // typography.allVariants paints every variant black, including the caption
        // styles helper text builds on. Restore MUI's grey; errors stay red.
        root: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
        },
      },
    },
    // MUI X v8 pickers render their own input (.MuiPickersOutlinedInput-root),
    // not .MuiOutlinedInput-root, so they miss the white fill above. Mirror it
    // here so date fields match every other input.
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: "small",
        variant: "outlined",
      },
    },
    MuiDateRangePicker: {
      defaultProps: {
        slotProps: {
          textField: {
            size: "small",
            InputProps: {
              style: {
                backgroundColor: "#fff",
              },
            },
          },
        },
      },
    },
    MuiDatePicker: {
      defaultProps: {
        slotProps: {
          textField: {
            size: "small",
            InputProps: {
              style: {
                backgroundColor: "#fff",
              },
            },
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        spacing: {
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem",
          paddingBottom: "1.25rem",
          paddingTop: "1rem",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          // Scoped to the root element only: MUI X applies these root overrides
          // to the .MuiDataGrid-scrollShadow overlay too, and a bare background
          // turns it into an opaque sheet that hides all rows on overflow.
          "&.MuiDataGrid-root": {
            backgroundColor: "#ffffff",
          },
          "& .MuiDataGrid-main": {
            backgroundColor: "#ffffff",
          },
          "& .MuiDataGrid-container--top [role=row]": {
            backgroundColor: "#fafafa",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#fafafa",
            fontSize: "0.875rem",
            color: "#424242",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 600,
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            paddingTop: "8px",
            paddingBottom: "8px",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#ffffff",
            "&:nth-of-type(even)": {
              backgroundColor: "#f9f9f9",
            },
            "&:hover": {
              backgroundColor: "#f0f7ff",
            },
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: "#fafafa",
          },
          "& .MuiDataGrid-selectedRowCount": {
            color: "#424242",
          },
        },
      },
    },
  },
});
